import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'nibtravel-error-message',
  template: `
    <ng-container *ngFor="let error of errors; let i = index">
      <div
        [attr.data-e2e]="e2eId"
        id="error-msg-{{ i }}"
        class="input-error-message"
      >
        <nibtravel-icon icon="close" state="error" size="sm"></nibtravel-icon>
        {{ error }}
      </div>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessageComponent {
  @Input() e2eId!: string;
  @Input() errors!: string[];
}
